module.exports = __webpack_public_path__ + "media/images/icons/automatic-attribute-f99e5cec828ce2b17413dceac6d3073d.png";